export default __webpack_public_path__ + "static/media/MongoDB_logo.cf4cb4a2.gif";